// * NOTE: If any one of these IDs change please ensure that the corresponding slug in `RatehubBrokerageSlugs.js` is also updated (if applicable).
export default [
    250, // Ratehub Brokerage 'ratehub-brokerage'
    270, // Ratehub Brokerage (Quebec) 'ratehub-qc'
    530, // Canwise Lender
];
